import { AxiosError, AxiosResponse } from "axios";

import { RESERVE_API_ENDPOINTS } from "@/features/reserves/api/endpointsReserve";
import apiRequests from "@/shared/config/axiosConfig";

type DeleteReserveResponse = {
  message: string;
  statusCode: number;
};

export default async function deleteReserve(
  reserveId: string
): Promise<DeleteReserveResponse> {
  try {
    const url = RESERVE_API_ENDPOINTS.DELETE_RESERVE.replace("{reserveId}", reserveId);

    const response: AxiosResponse<DeleteReserveResponse> = await apiRequests.delete(url);

    const { data, status } = response;

    if (status >= 200 && status < 300) {
      return data;
    }

    throw new Error(`Unknown error occurred with status code ${response.status}`);
  } catch (e) {
    const error = e as AxiosError;
    switch (error.response?.status) {
      case 400:
        throw new Error("400: Bad Request");
      case 401:
        throw new Error("401: Unauthorized");
      case 404:
        throw new Error("404: Not Found");
      default:
        throw new Error(
          `Unknown error occurred with status code ${error.response?.status}`
        );
    }
  }
}
